module.exports = __webpack_public_path__ + "img/img-shipin-s4-tuya.9abc9b42.png";